import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { Layout } from './components/Layout';
import { Upload } from './pages/Upload';
import { Share } from './pages/Share';
import { NotFound } from './pages/NotFound';
import { cloudflareAnalytics } from './utils/cloudflare';
import { generalAPI } from './utils/api';
import { useEffect } from 'react';

function App() {
  useEffect(() => {
    // Initialize Cloudflare analytics tracking
    cloudflareAnalytics.track('app_init', {
      timestamp: Date.now(),
      version: '1.0.0'
    });

    // Warm up backend worker to prevent cold starts
    generalAPI.warmUp();

    // Track page performance
    const trackPagePerformance = () => {
      if (typeof window !== 'undefined' && window.performance) {
        const navigation = window.performance.getEntriesByType('navigation')[0];
        if (navigation) {
          cloudflareAnalytics.track('page_performance', {
            loadTime: navigation.loadEventEnd - navigation.loadEventStart,
            domContentLoaded: navigation.domContentLoadedEventEnd - navigation.domContentLoadedEventStart,
            firstPaint: navigation.responseEnd - navigation.requestStart,
            timeToInteractive: navigation.loadEventEnd - navigation.navigationStart
          });
        }
      }
    };

    // Track performance after page load
    if (document.readyState === 'complete') {
      trackPagePerformance();
    } else {
      window.addEventListener('load', trackPagePerformance);
    }

    // Track user interactions
    const trackUserInteractions = () => {
      // Track clicks on important elements
      document.addEventListener('click', (event) => {
        const element = event.target;
        if (element.tagName === 'BUTTON' || element.tagName === 'A') {
          cloudflareAnalytics.track('user_interaction', {
            type: 'click',
            element: element.tagName,
            text: element.textContent?.substring(0, 50) || '',
            className: element.className || ''
          });
        }
      });

      // Track form submissions
      document.addEventListener('submit', (event) => {
        const form = event.target;
        if (form.tagName === 'FORM') {
          cloudflareAnalytics.track('form_submission', {
            formId: form.id || 'unknown',
            formClass: form.className || ''
          });
        }
      });
    };

    trackUserInteractions();

    // Cleanup function
    return () => {
      window.removeEventListener('load', trackPagePerformance);
    };
  }, []);

  return (
    <Router>
      <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
        <Layout>
          <Routes>
            <Route path="/" element={<Upload />} />
            <Route path="/share/:id" element={<Share />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
        <Toaster 
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
              borderRadius: '8px',
              padding: '16px',
              fontSize: '14px',
              maxWidth: '500px',
            },
            success: {
              iconTheme: {
                primary: '#10b981',
                secondary: '#fff',
              },
            },
            error: {
              iconTheme: {
                primary: '#ef4444',
                secondary: '#fff',
              },
            },
          }}
        />
      </div>
    </Router>
  );
}

export default App; 